import React, { useState, useEffect } from "react"
import Button from "@/components/core/Button/Button"
import { useDispatch, useSelector } from "react-redux"
import { setShowShippingDetails } from "@/store/features/cartSlice"
import {
  checkInactivePromos,
  refreshCart,
} from "@/components/checkout/checkoutHelperFunction"
import Modal from "@/components/core/Modal/Modal"
import { checkCartStock } from "@/utils/helper"
import { addPlaceOrderDataLayer } from "@/components/checkout/v1/checkoutAnalytics"
import OrderSummary from "@/components/cart/OrderSummary/OrderSummary"
import ShippingInfo from "@/components/cart/OrderSummary/ShippingInfo"
import useWindowResize from "@/hooks/useWindowResize"
import {
  checkoutState,
  setPaymentDisableBtnAction,
  setIsPaymentInfoAction,
  setPaymentTechnicalFailedAction,
  setPlaceOrderCountsAction,
} from "@/store/features/checkoutSlice"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/checkout/PaymentMethod/AciPayment/localization"
import {
  addAnalyticsForErrorCheckout,
  addAnalyticsForErrorMessages,
} from "@/components/checkout/PaymentMethod/analytics"
import ChekoutErrorMessage from "@/components/checkout/PaymentMethod/ChekoutErrorMessage"
import { addServiceAnalyticsData } from "@/components/checkout/analytics/index"

const OrderReview = props => {
  const {
    i18n,
    legalLinks = {},
    status,
    statusCode = {},
    shippingDone,
    shippingItems,
    setStepLoading,
    cart,
    summaryProps = {},
    shippingProps = {},
    orderSummary = false,
    placeOrderClick = () => {},
    placeOrderBtnDisableMsg = "",
    technicalErrorPopup = () => {},
    errorMessage = "",
    isModalOpen = false,
  } = props
  const { isPaymentDisableAction = false, placeOrderCounts = 1 } =
    useSelector(checkoutState)

  const [width] = useWindowResize()
  const [taxDown, setTaxDown] = useState(false)
  const [disablePaymentBtn, setDisablePaymentBtn] = useState(false)

  useEffect(() => {
    if (isPaymentDisableAction) {
      setDisablePaymentBtn(true)
    }
  }, [isPaymentDisableAction])
  const dispatch = useDispatch()
  const {
    isPaymentInfo = false,
    checkoutStep,
    isPaymentTechnicalErrorFailed = false,
  } = useSelector(checkoutState)
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  const { genericError = "" } = staticText

  useEffect(() => {
    if (status === statusCode?.EDIT) {
      dispatch(
        setShowShippingDetails({ Parcel: true, LTL: true, Services: true })
      )
    }
  }, [])

  const handleSubmit = async (isModalOpen = false) => {
    setStepLoading && setStepLoading(true)
    const res = await refreshCart
    if (res) {
      if (checkCartStock(cart)) {
        checkInactivePromos(setStepLoading, addPlaceOrderDataLayer, isModalOpen)
      }
    } else {
      setStepLoading && setStepLoading(false)
      addPlaceOrderDataLayer()
    }
  }

  const checkTaxFlag = () => {
    dispatch(setIsPaymentInfoAction(false))

    if (isPaymentTechnicalErrorFailed) {
      technicalErrorPopup()
      if (errorMessage && isModalOpen) {
        addAnalyticsForErrorMessages(errorMessage, "failure", isModalOpen)
      }
      dispatch(setPlaceOrderCountsAction(placeOrderCounts + 1))
      if (placeOrderCounts > 2) {
        dispatch(setPaymentTechnicalFailedAction(false))
        dispatch(setPaymentDisableBtnAction(true))
        placeOrderClick()
      }
    }
    if (cart?.custom?.fields?.taxCalculationFlag) {
      handleSubmit(isModalOpen)
    } else {
      setTaxDown(true)
      addPlaceOrderDataLayer()
    }
  }
  const onTaxModalClose = () => {
    placeOrderClick()
    setTaxDown(false)
    handleSubmit(isModalOpen)
  }

  return (
    <React.Fragment>
      <div className="taxware-down">
        <Modal
          showModal={taxDown}
          onModalClose={onTaxModalClose}
          labelledBy="taxware-down-title"
        >
          <div id="taxware-down-title" className="taxware-down__title">
            {i18n.taxDownTitle}
          </div>
          <div className="taxware-down__desc">{i18n.taxDownDesc}</div>
          <Button
            customClass="taxware-down__cta"
            role="button"
            flexible
            label={i18n.continue}
            onClick={onTaxModalClose}
          />
        </Modal>
      </div>
      {status === statusCode.EDIT && (
        <div className="review-order">
          {!orderSummary ? (
            <div className="review-order__order-summary">
              <OrderSummary checkoutMode={true} i18n={i18n} {...summaryProps} />
              {width < 992 && shippingDone && shippingItems.length > 0 && (
                <ShippingInfo
                  i18n={i18n}
                  cartItems={summaryProps?.cartItems}
                  shippingItems={shippingItems}
                  currencySign={summaryProps?.currencySign}
                  {...shippingProps}
                />
              )}
            </div>
          ) : null}
          {orderSummary && checkoutStep >= 2 ? (
            <>
              <div className="review-order__cta">
                <Button
                  role="button"
                  type="black"
                  label={i18n.placeOrder}
                  onClick={checkTaxFlag}
                  disabled={disablePaymentBtn || !isPaymentInfo}
                />
              </div>
              {disablePaymentBtn ? (
                <p className="paymentDisableMessage">
                  <ChekoutErrorMessage
                    customPaymentErrorMsg={placeOrderBtnDisableMsg}
                    genericPaymentErrorMsg={genericError}
                    onLinkClick={addAnalyticsForErrorCheckout}
                  />
                </p>
              ) : null}

              <div className="review-order__mssg">
                <p className="review-order__desc">
                  {i18n.agreeMssg}
                  <a
                    href={legalLinks?.termsOfService}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      addServiceAnalyticsData(
                        "terms of use",
                        legalLinks?.termsOfService
                      )
                    }
                  >
                    {i18n.termsOfUse}
                  </a>
                  {i18n.acknowledgeMssg}
                  <a
                    href={legalLinks.privacyPolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      addServiceAnalyticsData(
                        "privacy policy",
                        legalLinks?.privacyPolicy
                      )
                    }
                  >
                    {i18n.privacyPolicy}
                  </a>
                </p>
              </div>
            </>
          ) : null}
        </div>
      )}
    </React.Fragment>
  )
}

export default OrderReview
